import { observer } from "mobx-react"
import { useMemo } from "react"

import { IStatusChipProps, StatusChip } from "src/components/StatusChip"
import { IPollStatusChipProps } from "src/modals/polls/components/PollStatusChip/types"
import {
    POLL_STATUS,
    POLL_STATUS_OPTIONS,
} from "src/shared/polls/constants/polls-status"

export const PollStatusChip = observer(({ status }: IPollStatusChipProps) => {
    const chipProps = useMemo((): IStatusChipProps => {
        switch (status) {
            case POLL_STATUS.OPEN:
                return {
                    state: "positive",
                    label: POLL_STATUS_OPTIONS.open.name,
                }
            case POLL_STATUS.CLOSED:
                return {
                    state: "negative",
                    label: POLL_STATUS_OPTIONS.closed.name,
                }
            case POLL_STATUS.SCHEDULED:
                return {
                    state: "info",
                    label: POLL_STATUS_OPTIONS.scheduled.name,
                }
            case POLL_STATUS.DRAFT:
                return {
                    state: "neutral",
                    label: POLL_STATUS_OPTIONS.draft.name,
                }
            case POLL_STATUS.DELETED:
                return {
                    state: "dark",
                    label: POLL_STATUS_OPTIONS.deleted.name,
                }
            default:
                return {
                    state: "other",
                    label: status,
                }
        }
    }, [status])

    return <StatusChip {...chipProps} />
})
